import React from "react";
import OpcionDefecto from "../../../../../Common/Components/OpcionDefecto";
import CheckDefecto from "../../../../../Common/Components/CheckDefecto";

const ModalidadDistribucionLimiteTarjeta = ({ data, selectCheckBox, selectCombo }) => {
    const { GET_MODALIDAD_DISTRIBUCION_LIMITE, ERROR_PRODUCT, TipoProductoEmpInd } = data;
    const arrayAux = GET_MODALIDAD_DISTRIBUCION_LIMITE.filter(d => d.Checked);

    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">

                <label className="label-primary">{"Modelo de distribuci\u00F3n de l\u00EDmites entre integrantes de la Cuenta"}</label>
                <div className="container-radio radio-margin"><label className="label-secondary">{"Control de l\u00EDmite Cuentas de extensi\u00F3n / Adicionales"}</label></div>

                {GET_MODALIDAD_DISTRIBUCION_LIMITE.filter(x=> x.EmpresaIndividuos==TipoProductoEmpInd || x.EmpresaIndividuos=="A").map((item) => {
                    const referencia = `GMDL-${item.Id}`;

                    return (
                        <CheckDefecto
                            key={item.Id}
                            nombre={item.Descripcion}
                            check={item.Checked}
                            activo={item.Activo}
                            referencia={referencia}
                            selectCheckBox={() => selectCheckBox("GET_MODALIDAD_DISTRIBUCION_LIMITE", item.Id)}>
                            <ul className="no-bullets no-padding no-margin">
                                <li className="inlineListItem2 left-separator-md-secondary">
                                    <label className="label-secondary" htmlFor={referencia}>{item.Explicacion}</label>
                                </li>
                            </ul>
                        </CheckDefecto>
                    )
                })}

                <OpcionDefecto
                    selecciono={arrayAux.length}
                    infoData={arrayAux}
                    referencia={"DistribucionLimiteDefaultId"}
                    valorCombo={data.DistribucionLimiteDefaultId}
                    valorChecked={data.DistribucionLimiteDefaultInterfaz}
                    selectCombo={(value) => selectCombo("DistribucionLimiteDefaultId", value)}
                    selectCheckBox={(value) => selectCheckBox("DistribucionLimiteDefaultInterfaz", value)}
                />
                {(!data.ERROR_PRODUCT.seleccionoModeloDistribucion && arrayAux.length < 1 ) &&
                    <label className="error">{"Debe seleccionar al menos un modelo de asignación de límites"}</label>}
                
            </div>
        </div>
    );
}

export default ModalidadDistribucionLimiteTarjeta;